module.exports = __webpack_public_path__ + "static/media/lamina26img1.5f87fe40.png";